export type AppleCharMood = 'happy' | 'sleepy' | 'confused' | 'party'

export interface AppleCharProps {
  size?: number
  mood?: AppleCharMood
  color?: string
}

const STEM = '#7a4a2a'
const LEAF = '#69b46b'

function HappyFace() {
  return (
    <g>
      <circle cx="32" cy="48" r="3.5" fill="#fff" />
      <circle cx="56" cy="48" r="3.5" fill="#fff" />
      <path
        d="M30 60 Q44 70 58 60"
        stroke="#fff"
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
      />
    </g>
  )
}

function SleepyFace() {
  return (
    <g>
      <path
        d="M27 48 Q32 51 37 48"
        stroke="#fff"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M51 48 Q56 51 61 48"
        stroke="#fff"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M38 62 Q44 60 50 62"
        stroke="#fff"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <text x="62" y="36" fontSize="14" fill="#fff" fontWeight="700">
        z
      </text>
    </g>
  )
}

function ConfusedFace() {
  return (
    <g>
      <circle cx="32" cy="48" r="3.5" fill="#fff" />
      <line
        x1="51"
        y1="44"
        x2="61"
        y2="52"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="61"
        y1="44"
        x2="51"
        y2="52"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M30 64 Q44 56 58 64"
        stroke="#fff"
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
      />
    </g>
  )
}

function PartyFace() {
  return (
    <g>
      <path
        d="M28 50 Q32 44 36 50"
        stroke="#fff"
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M52 50 Q56 44 60 50"
        stroke="#fff"
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M28 58 Q44 74 60 58"
        stroke="#fff"
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="20" cy="20" r="2.5" fill="#F4B942" />
      <circle cx="70" cy="22" r="2" fill="#2ECC71" />
      <circle cx="14" cy="44" r="1.8" fill="#2481CC" />
    </g>
  )
}

export function AppleChar({ size = 80, mood = 'happy', color }: AppleCharProps) {
  const c = color ?? '#E63946'

  const face =
    mood === 'happy' ? (
      <HappyFace />
    ) : mood === 'sleepy' ? (
      <SleepyFace />
    ) : mood === 'confused' ? (
      <ConfusedFace />
    ) : (
      <PartyFace />
    )

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 88 88"
      aria-hidden="true"
    >
      {/* leaf */}
      <path d="M48 14 Q60 6 66 14 Q60 22 48 18 Z" fill={LEAF} />
      {/* stem */}
      <rect x="42" y="12" width="3" height="10" rx="1.5" fill={STEM} />
      {/* apple body */}
      <path
        d="M44 20 C20 20 12 42 16 60 C20 76 32 82 44 78 C56 82 68 76 72 60 C76 42 68 20 44 20 Z"
        fill={c}
      />
      {/* highlight */}
      <ellipse cx="32" cy="36" rx="6" ry="9" fill="#fff" opacity="0.18" />
      {face}
    </svg>
  )
}
